import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
import { ProductBreakdown } from '../components/ProductBreakdown';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { CTAButton } from '../components/CTAButton';
export const SalesPage: React.FC = () => {
  return <div className="min-h-screen bg-stone-50 font-sans text-gray-900" data-id="element-177">
      <Hero data-id="element-178" />
      <ProblemSection data-id="element-179" />
      <SolutionSection data-id="element-180" />
      <BeforeAfterSection data-id="element-181" />
      <ProductBreakdown data-id="element-182" />
      <BonusSection data-id="element-183" />
      <Testimonials data-id="element-184" />
      <PricingSection data-id="element-185" />
      <FAQ data-id="element-186" />

      {/* Final CTA Section */}
      <section className="py-20 bg-white text-center" data-id="element-187">
        <div className="container mx-auto px-4 max-w-2xl" data-id="element-188">
          <h2 className="text-3xl font-bold mb-6" data-id="element-189">
            Ciencias puede ser una materia increíble...
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-190">
            Si tenés estructura, recursos claros y prácticas que se pueden
            aplicar. Este MegaPack no te promete magia. Te promete algo real:{' '}
            <span className="font-bold text-green-700" data-id="element-191">
              más tiempo, menos estrés y mejores clases.
            </span>
          </p>
          <CTAButton text="Sí, quiero Ciencias Naturales lista todo el año" data-id="element-192" />
        </div>
      </section>

      <footer className="bg-stone-900 text-stone-400 py-8 text-center text-sm" data-id="element-193">
        <div className="container mx-auto px-4" data-id="element-194">
          <p data-id="element-195">
            © {new Date().getFullYear()} MegaPack Ciencias Naturales. Todos los
            derechos reservados.
          </p>
          <p className="mt-2" data-id="element-196">
            Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-197" />
    </div>;
};